import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useStratifiedProductionChartsDataContext } from './hooks/useStratifiedProductionChartsDataContext';

export const ServicesBySex = () => {
    const { chartData } = useStratifiedProductionChartsDataContext();

    return (
        <Donut
            title={'Atendimento por sexo'}
            subtitles={chartData?.servicesBySex?.map((item) => item.description)}
            chartData={chartData?.servicesBySex || []}
            colors={defaultColors.slice(0, chartData?.servicesBySex?.length) || []}
            height={450}
        />
    );
};
